"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareStakingRulesInitialValues = exports.stakingRulesFilter = void 0;
const stakingRulesFilter = ({ title, description, imageUrl }) => ({
    title,
    description,
    imageUrl,
});
exports.stakingRulesFilter = stakingRulesFilter;
const prepareStakingRulesInitialValues = ({ id, title, imageUrl, description, penalty, recurrent, deposit, reward, durationAmount, durationUnit, stakingRuleStatus, contractId, maxStake, }) => {
    return {
        id,
        title,
        imageUrl,
        description,
        deposit,
        reward,
        penalty,
        recurrent,
        durationAmount,
        durationUnit,
        stakingRuleStatus,
        contractId,
        maxStake,
    };
};
exports.prepareStakingRulesInitialValues = prepareStakingRulesInitialValues;
//# sourceMappingURL=schemas.js.map